import React from 'react';
import {
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col
} from 'reactstrap';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import InputDatetime from '../../../components/Form/InputDatetime/InputDatetime';
import { hasError, errorMessage, textChange, textValue, checkChange } from '../../../utils/form';
import { isNumeric } from '../../../utils/regex';
moment.tz('Asia/Jakarta');
export class ModalCommission extends React.Component{
  constructor(props){
    super(props);
    this.state={
      id:null,
      commission_amount:null,
      max_amount: null,
      started_at:null,
      ended_at:null,
      isSubmit:false,
      isAletError:false,
      error:null
    }
    this.handleChange=this.handleChange.bind(this);
    this.onSubmit=this.onSubmit.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
  }

  componentDidUpdate(preProps){
    const { dataCommission, commissionSelected } = this.props;
    if(this.props.isOpen===true&&preProps.isOpen!==this.props.isOpen){
      if(commissionSelected){
        this.setState({
          id:commissionSelected.id,
          commission_amount: commissionSelected.commission_amount,
          max_amount: commissionSelected.max_amount ? parseInt(commissionSelected.max_amount): commissionSelected.max_amount,
          started_at: moment(commissionSelected.started_at).isValid()? moment(commissionSelected.started_at): commissionSelected.started_at,
          ended_at: moment(commissionSelected.ended_at).isValid()? moment(commissionSelected.ended_at): commissionSelected.ended_at,
          error: null
        });
      }
    }
    else if(this.props.isOpen===false&&preProps.isOpen!==this.props.isOpen) {
      this.setState({
        id:null,
        commission_amount:null,
        max_amount: null,
        started_at:null,
        ended_at:null,
        isSubmit:false,
        isAletError:false,
        error:null
      },()=>this.props.onRemoveSelected());
    }
    if(dataCommission.isSubmit!==preProps.dataCommission.isSubmit
      &&dataCommission.isSubmit===false){
        const { error, isDelete } = dataCommission;
        if(error)
          this.setState({
            error:{...dataCommission.error},
            isSubmit:false, isAlertError:true},
          );
        else if(!isDelete){
          this.setState({
            isSubmit:false,
            started_at:null,
            ended_at:null,
          },()=>{this.props.onCancel()});
          this.props.onGetCommissionList();
        }
    }
  }

  handleChange(e){
    this.setState(textChange(e,{...this.state}));
  }

  handleDatePickerChange(date, name){
    this.setState({[name]: date})
  }

  onDismiss() {
    this.setState({
      isAlertError: false,
      error: null
    }, ()=>{this.props.onRemoveSelected()});
  }

  _validateForm(){
    let errors={};
    const { commission_amount, max_amount, started_at, ended_at } = this.state;
    if(!commission_amount)
      errors['commission_amount']=['The commission amount field is required..'];
    else{
      const priceInt = parseInt(commission_amount)
      if(priceInt > 100){
        errors['price']=['The price may not be greater than 100..'];
      }
    }
    if(max_amount && !isNumeric(max_amount))
      errors['max_amount']=['The max amount must be numeric..'];
    if(ended_at && !moment.isMoment(ended_at) && ended_at !== '')
      errors['ended_at'] = ['Invalid date. format: DD/MM/YYYY HH:mm.'];
    if(started_at && !moment.isMoment(started_at) && started_at !== '')
      errors['started_at'] = ['Invalid date. format: DD/MM/YYYY HH:mm.'];
    if(Object.keys(errors).length){
      this.setState({
        error:{errors:{...errors}, status_code:422,message:'Please fulfill your form *'}
      })
    }
    return errors;
  }

  onSubmit(e){
    e.preventDefault();
    const valid= this._validateForm();
    if(Object.keys(valid).length===0){
      let payload = {
        variant_id:this.props.variantId,
        update:this.state.id?true:false,
        commission_amount: this.state.commission_amount,
        max_amount: this.state.max_amount,
        started_at: moment.isMoment(this.state.started_at)? this.state.started_at.format("YYYY-MM-DD HH:mm:00"): null,
        ended_at: moment.isMoment(this.state.ended_at)? this.state.ended_at.format("YYYY-MM-DD HH:mm:00"): null,
      }
      this.setState({
        isSubmit:true,
        error:null,
      },()=>{
        this.props.onSubmit(payload,this.state.id);
      });
    }
  }

  _renderError(){
    const { error, isAlertError } = this.state;
    if(error!==null){
      switch(error.status_code){
        case 422:
          return <Alert color="danger" isOpen={isAlertError} toggle={this.onDismiss}>Please fulfill your form</Alert>
        default:
          return <Alert color="danger" isOpen={isAlertError} toggle={this.onDismiss}>Houston, we have a problem!. Please inform our friendly staff via LINE @kickavenue</Alert>
      }
    }
    return null;
  }

  render(){
    return(
      <Modal isOpen={this.props.isOpen} toggle={this.props.onCancel} className="modal-dialog modal-md">
        <Form onSubmit={this.onSubmit}>
          <ModalHeader toggle={this.props.onCancel}>
            {this.state.id === null? 'Add Selling Commission': `Edit Selling Commission - ID: ${this.state.id}`}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col xs={12} md={6}>
                <FormGroup
                  className={classnames({
                    "has-danger has-feedback": hasError(
                      "commission_amount",
                      this.state.error
                    )
                  })}
                >
                <Label for="formCommissionAmount">
                  Commission Amount (%)
                </Label>
                <Input
                  type="number"
                  id="formCommissionAmount"
                  name="commission_amount"
                  placeholder="Enter a commission amount"
                  value={textValue("commission_amount", this.state)}
                  onChange={this.handleChange}
                />
                  {errorMessage("commission_amount", this.state.error)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup
                    className={classnames({
                      "has-danger has-feedback": hasError(
                        "max_amount",
                        this.state.error
                      )
                    })}
                >
                  <Label for="formMaxAmount">
                    Max Amount (Rp)
                  </Label>
                  <Input
                    type="number"
                    id="formMaxAmount"
                    name="max_amount"
                    placeholder="Enter a max amount"
                    value={textValue("max_amount", this.state)}
                    onChange={this.handleChange}
                  />
                    {errorMessage("max_amount", this.state.error)}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <FormGroup  className={classnames({'has-danger has-feedback':hasError('started_at',this.state.error)})}>
                  <Label for="formStartedDate">Start Date - optional</Label>
                  <InputDatetime
                    name="started_at"
                    id="formStartedDate"
                    timeFormat="HH:mm"
                    value={textValue('started_at',this.state)}
                    onChange={(date)=>this.handleDatePickerChange(date,'started_at')}
                    inputProps={{placeholder:'Pick a Started At', id:'formStartedDate'}}
                  />
                  {errorMessage('started_at',this.state.error)}
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup  className={classnames({'has-danger has-feedback':hasError('ended_at',this.state.error)})}>
                  <Label for="formEndedDate">End Date - optional</Label>
                  <InputDatetime
                    name="ended_at"
                    id="formEndedDate"
                    timeFormat="HH:mm"
                    value={textValue('ended_at',this.state)}
                    onChange={(date)=>this.handleDatePickerChange(date,'ended_at')}
                    inputProps={{placeholder:'Pick a Ended At', id:'formEndedDate'}}
                  />
                  {errorMessage('ended_at',this.state.error)}
                </FormGroup>
              </Col>
            </Row>
          <span>{this._renderError()}</span>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" onClick={this.props.onCancel}>Cancel</Button>
            <Button type="submit" color="primary" disabled={this.state.isSubmit} onClick={this.onSubmit}>{this.state.isSubmit?'Submitting...': 'Submit'}</Button>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }
}
ModalCommission.propTypes={
  dataCommission: PropTypes.object,
  commissionSelected: PropTypes.object,
  onGetCommissionList: PropTypes.func.isRequired,
  onRemoveSelected: PropTypes.func.isRequired,
  isOpen:PropTypes.bool,
  onSubmit:PropTypes.func,
  onCancel:PropTypes.func
}